import Image from "next/image";
import { FC, useState } from "react";
import Icon from "~/components/Icon";
import Text from "~/components/Text";
import Colors from "~/constants/colors";
import styles from "./FileItem.module.scss";

interface FileItemProps {
  file: IFile;
  onDelete?: () => void;
}

const FileItem: FC<FileItemProps> = ({ file, onDelete }) => {
  const isVideo = file.type.startsWith("video");
  const [duration, setDuration] = useState(0);

  // parse duration to minute:second
  const parseDuration = (duration: number) => {
    const minutes = Math.floor(duration / 60);
    const seconds = Math.floor(duration % 60);

    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <div className={styles.file_item}>
      {isVideo ? (
        <video
          src={file.url}
          className="h-full w-full object-cover rounded"
          onLoadedMetadata={(e) =>
            setDuration((e.target as HTMLVideoElement)?.duration || 0)
          }
        />
      ) : (
        <img
          src={file.url}
          alt={file.name}
          className="object-cover rounded w-full h-full"
        />
      )}
      <Icon
        name="close"
        className={styles.close_icon}
        color={Colors.GREY_400}
        size={20}
        onClick={() => onDelete?.()}
      />
      {isVideo && duration ? (
        <div className={styles.timestamp}>
          <Icon name="video-2" size={14} color={Colors.GREY_00} />
          <Text type="body-4" color={Colors.GREY_00}>
            {parseDuration(duration)}
          </Text>
        </div>
      ) : null}
    </div>
  );
};

export default FileItem;
